import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import ImagePreview from './ImagePreview'

export default class ImagePreviews extends React.Component {
  static propTypes = {
    images: PropTypes.array.isRequired,
    currentOriginalImageID: PropTypes.string,
    imageIDPath: PropTypes.string,
    renderImagePreview: PropTypes.func,
    isImagePreviewRemoveBtn: PropTypes.bool,
    onImageSelect: PropTypes.func,
    onImageRemove: PropTypes.func,
  }

  static defaultProps = {
    imageIDPath: 'imageID',
  }

  state = {
    selectImages: [],
  }

  isImageSelect = imageID => _.includes(this.state.selectImages, imageID)

  getImageID = image => _.get(image, this.props.imageIDPath)

  renderImagePreview = (image, i) => {
    const imageID = this.getImageID(image)
    const isSelect = this.isImageSelect(imageID)
    console.log(imageID + _.get(image, 'lastChecked'))
    return (
      <ImagePreview
        key={imageID}
        onImageSelect={this.props.onImageSelect}
        isSelect={isSelect}
        isRemoveBtn={this.props.isImagePreviewRemoveBtn}
        imageID={imageID}
        lastChecked={_.get(image, 'lastChecked')}
        originalImageID={this.props.currentOriginalImageID}
      />
    )
  }

  render() {
    if (this.props.images) {
      return (
        <GroupImageLayout>
          {_.map(
            _.orderBy(this.props.images, ['desc']),
            this.props.renderImagePreview || this.renderImagePreview,
          )}
        </GroupImageLayout>
      )
    }
    return null
  }
}

const GroupImageLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
`
GroupImageLayout.displayName = 'GroupImageLayout'



// WEBPACK FOOTER //
// ./src/components/templates/image-preview/ImagePreviews.js